<template>
    <div class="sign_list">
        <div style="height:186px;margin-bottom:14px;">
            <div v-for="(item , index) in dataList" :key="index">
                <div style="float:left;" class="sign_item" v-if="index<4">

                    <div v-if="item.isSignIn" class="item_model" style="background:#FFE292;">
                        <div class="sign_date" style="color:#A65307;">{{item.taskTitle}}</div>
                        <div class="sign_img"><img src="icon/userIcon/sign_integral.png" alt=""></div>
                        <div class="sign_status" style="color:#A65307;">已签到</div>
                    </div>
                    <div v-else class="item_model">
                        <div class="sign_date">{{item.taskTitle}}</div>
                        <div class="sign_img"><img src="icon/userIcon/sign_integral.png" alt=""></div>
                        <div class="sign_status">
<!--                            {{item.remark}}-->
                            &nbsp;
                        </div>
                    </div>

                </div>
                <div v-else-if="index< 6" class="sign_item" style="float:right;">

                    <div v-if="item.isSignIn" class="item_model" style="background:#FFE292;color:#A65307;">
                        <div class="sign_date" style="color:#A65307;">{{item.taskTitle}}</div>
                        <div class="sign_img"><img src="icon/userIcon/sign_integral.png" alt=""></div>
                        <div class="sign_status" style="color:#A65307;">已签到</div>
                    </div>

                    <div v-else class="item_model">
                        <div class="sign_date">{{item.taskTitle}}</div>
                        <div class="sign_img"><img src="icon/userIcon/sign_integral.png" alt=""></div>
                        <div class="sign_status">
<!--                            {{item.remark}}-->
                            &nbsp;
                        </div>
                    </div>

                </div>
                <div v-else class="sign_item" style="width:50%;float:right;">
                    <div v-if="item.isSignIn" class="sign_end_item vip_bg">
                        <div class="sign_date" style="color:#543E2B">{{item.taskTitle}}</div>
                        <div class="end_state" style="color:#C29063">
<!--                            {{item.remark}}-->
                            &nbsp;
                        </div>
                        <div class="end_singIn">已签到</div>
                    </div>
                    <div v-else class="item_end">
                        <div class="sign_date">{{item.taskTitle}}</div>
                        <div class="end_state">
<!--                            {{item.remark}}-->
                            &nbsp;
                        </div>
                        <div class="end_img">
<!--                            <img src="icon/userIcon/sign_vip.png" alt="">-->
                            &nbsp;
                        </div>
                    </div>

                </div>

            </div>
        </div>


        <div @click="tomorrowSign" class="btn_sign" v-if="signState.isSignIn">
            <img src="icon/userIcon/tomorrow_sign.png" alt="">
        </div>
        <div @click="todaySign(signState.isYesterdaySignIn)" class="btn_sign" v-else>
            <img src="icon/userIcon/today_sign.png" alt="">
        </div>

        <div class="day_sign">
            <div>已连续签到<span style="color:#FE9219;">{{signState.continuousCount || 0}}</span>天</div>
        </div>

        <div v-if="isNOSignDrawer" class="box">
            <!-- 遮罩 -->
            <div class="box1" @click="isNOSign">

            </div>
            <!-- 内容 -->
            <div class="box2">

                <div class="box3">
                    昨天未签到，需重新签到哦～
                </div>
                <div @click="isNOSign" class="box4">
                    好的，知道了
                </div>
            </div>
        </div>

        <div v-show="isTomorrowDrawer" class="box">
            <!-- 遮罩 -->
            <div class="box1" @click="isTomorrowDrawer = false">

            </div>
            <!-- 内容 -->
            <div class="box2">

                <div class="box3">
                    今日已签到，明日再来吧~
                </div>
                <div @click="isTomorrowDrawer = false" class="box4">
                    好的，知道了
                </div>
            </div>
        </div>

    </div>
</template>
<script>

// part
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// platformApi
import requestManager from '@comp/platformApi/requestManager';

// util
import appHelper from '@util/appHelper';
import consoleHelper from '@util/consoleHelper';

const config = {
    apiConfig: {
        list: {
            url: '/portal/v4/user/center/task/signInTaskList',
            dataPath: 'data',
            // totalPath : 'data.total',
            // totalPagePath : 'data.pages'
        }
    }
};


export default {
    name: "signInList",
    extends : shixunPagePart,
    props: ['paramTaskValue'],
    watch: {
        paramTaskValue(val, oldVal) {
            this.reloadDataList();
            this.getSignState();
            //  this.getSignReturn();

        },
    },
    data() {
        return {
            enableDataList: true,
            autoLoadDataList: true,
            scrollToLoadNextPage: false,
            apiConfig: config.apiConfig,
            signState: {},
            isNOSignDrawer: false,
            isTomorrowDrawer: false,


        }
    },
    methods: {
        async isNOSign() {
            let res = await this.getSignReturn();
            consoleHelper.log(res)
            if (res === true) {
                appHelper.showHint('今日已签到成功');
                this.reloadDataList();
                this.getSignState();
                this.$emit('isChange', 'true');
                this.isNOSignDrawer = false
            } else {
                appHelper.showHint('签到失败');
                this.isNOSignDrawer = false
            }

        },

        getSignState() {

            requestManager.request({
                url: '/portal/v4/user/center/task/getSignInfo',
            }, (error, result) => {
                if (error)
                {
                    appHelper.generalAjaxError(error);
                    return;
                }
                this.signState = result.data;
            });

        },
        getSignReturn() {


            requestManager.request({
                method: 'post',
                url: '/portal/v4/user/center/task/signIn',
            }, (error, result) => {
                if (error)
                {
                    appHelper.generalAjaxError(error);
                    return;
                }
                consoleHelper.log(result.data.result);

                if (result.data.result === true) {
                    appHelper.showHint('今日已签到成功');
                    this.reloadDataList();
                    this.getSignState();
                    this.$emit('isChange', 'true')
                } else {
                    appHelper.showHint('签到失败')
                }
            })
        },

        todaySign(noSign) {
            if (noSign === false) {
                this.isNOSignDrawer = true
            } else {
                if (this.signState.isSignIn === false || this.signState.isSignIn === null) {
                    this.getSignReturn();
                } else {
                    appHelper.showHint('签到失败')
                }
            }

        },
        tomorrowSign() {
            this.isTomorrowDrawer = true;
        },

    },
    mounted() {
        this.getSignState();
    }
}
</script>
<style lang="scss" scoped>

.box1 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: #000;
    opacity: .5;
    z-index: 999;
}

@keyframes mybox2 {
    0% {
        //    left: 0;
        opacity: 0;
    }
    100% {
        //    left: 50%;

    }


}

.box2 {
    width: 249px;
    height: 140px;
    background: #FFFFFF;

    border-radius: 8px;
    z-index: 9999;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    animation: mybox2 .5s;
}

.box3 {
    width: 100%;
    height: 96px;
    line-height: 96px;
    text-align: center;

    font-size: 16px;
    font-weight: 400;
    color: #333333;

}

.box4 {
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
    border-top: 1px solid #EEF2F3;
    font-size: 14px;
    font-weight: 400;
    color: #FF4045;

}


.sign_end_item {
    border-radius: 4px;
    margin: 0;
    padding: 15px;
}


.end_singIn {

    font-size: 12px;
    font-weight: 400;
    color: #7E5B3C;

}


.vip_bg {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAS0AAACuCAYAAABjsFssAAAgAElEQVR4Xu2dCZAcZ3XH39fX9Fwr7UoraaWVZK8lWVodNoY4HAbbYK4iIaHIGmPiXGVIArkMFOQsjXORVIUrBhIcIAnORVQhCS7CDXYOB+zYGNtaYyGtZVgsa0fSaHd2jp6+Uq9nejU70193z329rpItbXd//X2/r/df73v9vvcY0EEEiAARGCACbID6Sl0lAkSACACJFr0ERIAIDBQBEq2Bmi7qLBEgAp0Qrbo2beJMBIjASBDgCEpbJaAdouW0Ud2rOwEYpFIjMUk0SCJABDwIpFJwdL0sVPuiWhKxVkSLuU+uFqnjx4+zucoY5tPpVtqnd4EIEIEBJTA7OWkfq/T94MGDZamoCFmVKDQlXs2IyiWxSqWYK1KuQE1ls06bZ4pFBrOzTl/L/6WDCBCBYSYwXzW4qYWFNUE6k0w6f0chm0cBq7LCKgLUkHg1KlqOYKFldXxujh2sWFJzb59T91x9xaslSXq5IIqvBYDLh3lyaGxEgAiEImDalvWwaVlfMIra1z79M0e/iQJWK16NClcjolUWrFSKzR4/ztCyQqvqZ//hj2+KRJSPAiOhCjWNdBERGFECtmXdu7q0/O5/fPsfPV0tXkdTKbsR4QolWjYAW/Nb3XefgGJ12S03Kje98bUfFEThrSM6BzRsIkAEGidQKBVKb33fG9957PrJSStdWTI2IlxhRGvNwoKKYGlbtgjv+Mi73i9I4jsa7zPdQQSIwGgTsE0tp73+c0c/9dXMwoI9PjNjoa8rrHAFiZanYP3i+3/1J5V49J9GGzyNnggMKgEGwBiAXe3/bsgX3vLAbdu++Oz8qcOfveuz6cjSkuUI17FjNoZJYM/8HhAoWikANjs3xzILCwJaWHuu3RN5zc+/4VHGGDnbW546aoAIdJkAEwDDKNd0YU24uitaOGpd1z/+kduO3jE9PW3Op9PW8clJ++CxY3aq3Dluh/xEy7Gybp6bE/Ar4ezkpLAIIP5y6uduUROxT3UZNT2OCBCBlggwAEGst64caXD1obvCZdtQ/N6D393zwMc+c/6ZdNqCyUkLbrjBqiwTGxctx/meSjHXj6Ukk+I5RRHf9Rfv+TsmiT/ZEj+6mQgQge4RQOuKiR7WVUWweihceq54+1+/92P/qBmGWb1M9LO2eJbWOitrIhoVtyUSQlbTpF/48G88DgLb3T3i9CQiQASaJiBIleWg24JdMaxqrKseCZdeKn3sr377E+/VFhfNlelpE9DiCrC2uKJV7ctCK0tUFFEQRfEtf/me5wAg2jREupEIEIEuEMDloFx2XzkGVY3T3UukeuDfMg3z3r+948/fYti2idbWE0tLVmZmxvrnY8csXuyWp2hVLw0dX9biohiZnhZjui793Id/PdMF4vQIIkAEmiWAS0HHwmrCunKEq3u+LdMwvvzJ37z75ujysmGWSib6tmZnZ00MgUilUp6d8RKtdWEOuDSMSJIoMSaqiYR06/veeqFZlnQfESACHSaA1pXjcK/4qwKFq9YCszrcwfXNo2jd866Pvikvy4YGYK7Mz5tBDnlv0bJtuPnmm4WbFhaEM8mkGFcUcWzDBkk1DOlnPvRr57o6KnoYESACIQgwADFSjr8qrwfD+65c66rLVhb20jStL3/mdz95S3F11XCXiBcKBbPKr1WrvvXplt2lIe4vxNgs9GflAaTSxo1SzDSlt33knekQBOkSIkAEukUAvw6iYFXHX/kKV611hQJndqu3655jGuZX/uY3P36Lurpq5CTJcP1a23/8x82jR4/arCzC69arXllGnVAHR7TGx4VcJiNFABx/ViQald78J28j0erJ9NJDiYAHAVwOikqT1hXKgdUzwXIsLcP8yt+/+6NvLkqSsbK8bORKJXMqmzXdrT1efi2uaGF8lhtQqmualDRNSY3FpJ//s7cv0ctDBIhAHxAQ1YrDPeDLIM+/hdZVjywslx6K1id/95O35gsFQ5FlI5ZOG6V9+8zxTMbZj9iUaAGAiPFZ6IRfKRTkX/rQr53tg+miLhCBESbAAOQYgLMlJ6Tvqlq40Hdl6zVhEL3BaejGV4/93qferBUKhuOMr8RrzQJwvyAGWlqZYlHSDEOKJRKSYhjSbSRavZldeioRQAJMApBrwyQ9hItrXVkAVqlvWKJo3fNbd9/KdF1vi2i54Q6uaNmaJt9+1x0YXEoHESAC3SaAznZJbc66wr5aBoCld7vXvs9zRauYzxtZUTTkdNrAyPimLS0Srb6aX+rMyBKoLAeDAkbXXFtVW3Sc8Ey7bF312H/lNX0kWiP7UtPAh5YARrfLCQBBqPigAvYM1i4L8eugqZW/EvbhQaLVh5NCXSICTRPAUAY5fun2ur2Bri8LL6mxrvDflglgFpt+fDduJNHqBmV6BhHoBgEUK/Rf1QoVV7iqwh7wGrPUVw53HjISrW68TPQMItBJAhjGoIyV9w86BlRNDNa6n3lYV45gFctO9wE4SLQGYJKoi0SASwCj2yNjVfmvKqLklTKmbp8gLgctAD2PnwkHBjKJ1sBMFXWUCNQQkKIASiK8dVUrZBjK4AjWYB0kWoM1X9RbIlC2qtC6cjY8O2u/GuGq8VXVXuMuB/EL4QAeJFoDOGnU5REmgP4rdcK74ISjX7XhDR65r/TcwPivvGaaRGuE338a+oARQMsqsrGS/6pB6wqHiuEMpZWuZhntBGESrU5QpTaJQLsJKMmy/yrMl8G63O6VcAZ9td296kl7JFo9wU4PJQJhCQgA0fGK/6oJ6woFDJeDfR4wGpYGXkei1QgtupYIdJMA7huMbq6kk3EfzEkr4+XPwuWgtgJgD0b8VVi0JFphSdF1RKCbBDD3FTrc674MOurEyeVe5XTH6HZteeD9V+SI7+ZLR88iAk0RYADqeGX/oEf0utOmu0ys+nu1uBl5gNJw+K9ItJp6iegmItBFArgcdBP2NVQsFbWsshwc0PirsJRpeRiWFF034ARYOVSgByWvQoNDCwu/Eq6zpgLSyri+LNw3WMz0Zf6r0OMPeSGJVkhQdNkAE8D8Uq4Q9LNoje2s2kMY0neFy0K0rAqjUw+ZRGuAfxep60EEWFWpd3ReVyqm96Nw4ZfC5I6Ktoa0rnAcpSzAkMRfBc2me55EKywpum6wCKB1hRkQHAe1h2D1m3Dh9pyxXeG+DDrJ+iyA4oWylTViB4nWiE34SAxXUC7V9qu1rtb+jalY1hUh7j2a5HRVTqzK8tDLv4XZGfLpvk2H3GmQJFqdJkztd5EAA8B0LU5ZdB/ryqnh15uS7r4w5CRAbJNPbBZGt+fLFtYIHyRaIzz5QzV0p5hDrN7hXmtpYZR4PwqWOxnRTZUviDVbdrDIBH4dxC05I36QaI34CzAUw3dq+2ExUj/rCguOYoXkAcjQicvbKKafkcr9xej2wvn+W8726OUh0eoReHpsmwhgqSysQOMrWCaAgQ7rPvNhtQnBqDVDojVqMz4048VkeJhbSqgRrIqD3V0WmsZQZTgYmulrYSAkWi3Ao1t7RACXT+qG8sO5XwcrQZcjGBLQo1np2mNJtLqGmh7UFgJSHCCCW10Cvg46KYX1tjySGukvAiRa/TUf1BsugUr2AyxG6idYuAcPc0iR/2po3yUSraGd2mEaGAOIb6sq5lBlZbkC5lSY0So50Idp7DSWWgIkWvRO9D8BLOaAS0I//xXmj8I8UnQMPQESraGf4iEYYGwLAG9Z6O7BI//VEEx0uCGQaIXjRFf1kgDmmcLipLWWFgZd5s+R/6qXc9ODZ5No9QA6PbJBAhiLldhRFZNl0R68BhEO0+UkWsM0m8M+Ftyug/sL0X9Fy8Fhn23u+Ei0RnbqaeBEYDAJkGgN5rxRr4nAyBIg0RrZqaeBE4HBJECiNZjzRr0mAiNLgERrZKeeBk4EBpMAidZgzhv1mgiMLAESrZGdeho4ERhMAiRagzlv1GsiMLIESLRGdupp4ERgMAmQaA3mvFGvicDIEiDRGtmpp4ETgQYJ4B5QrBCE5drw7059SVapcIRVr83yH6dEW+eKiJBoNThvdDkRGBkCglyudCSIzQ3ZTcxoYtrr9okYiVZz00F3EYEhJYBVulUAUW7v+LB+I1bHbkPdSRKt9k4NtUYEBpQAA5Cj5eVfJw+0vhzxwiVkcweJVnPc6C4iMDwEHMsKC9528UDfF4pXE8tGEq0uzhM9igj0FQF0pGOFbseh3qNDLzScG41Eq0dzRY8lAj0lgE52XA72w4GOeqMQuickWqFR0YVEYEgIYAZYKdJfg3GWi7lQfSLRCoWJLiICQ0IAfVdOZaM+PEIKF4lWH84ddYkIdIRAPwuWO2CsEO446PkHiVZH3g5qlAj0GQGMYlfifdYpTncMrVwtnHdaN756z2/dfWsxnzeyomjI6bSxMj1tzgKY8wcP2qlUCiNZ10Wz1n1qsAHYnakUg/vuEyaiUTEiSaJmGFIskZBsTZNvv+uO5waDFvWSCAwjAQag9PgrYaNYfb4qkqXVKEy6nggMGgEp2v4I904zwCDUUtbzKSRanYZP7ROBXhLACHesFTmIBycUgkRrECeT+kwEwhLA4FFBCHt1/12HhXlr9iuSaPXfNFGPiEB7CPRTAGmzI/Kwtki0moVJ9xGBficgx5tPK9MvY3N8Wxh0aq31iESrXyaH+kEE2kkAk/ShaPVyX2G7xlMTAkGi1S6w1A4R6CcCogogdTlzQ6fGb2EurlWytDrFl9olAn1BYNAd8LUQNRSt8hKRLK2+eMOoE0SgnQQGMJg0aPhVwaYkWkGw6DwRGDQCw/DVsJZ51VdEEq1BeyGpvz0nYKycAy19mtuP+OXP68hXO+3sKTBWM57PVaf2ghjbUD5Xk3pGzzwLpbMnuf2VJ6ZB2TIDKw99tjm2ggBifALE2EYQExMgb5xq//irMkCQaDU3TXTXCBMwsucgf/IhLoHEwetBUNobhW6bOmQf+6r3M0UFkodfDsz9UlizbWf1sS+DlfcWO2wwfuQ1juCtfPMz7ZtVp9yYAMrUlaBuP9C6iFVt6yHRat80UUsjQsDS8rA6fz93tLE914KU3NRWGtrZBdCefcqzTWXbXlCn9lw6h9t2KgUqzPxFyD32JW5fxMRmiB96hXO+raK17okMhGgSYvtfBkKkhUwT2orTKolWW18tamwUCNi2DdlHv8gdqrrrMCibptuKInv8PrBL3imJk4dfAaw6vKEqqLRw6kHQ009z+xLd+2KQN+3ssGi5j2cgb52B6OUvaI6NhhuobRKt5ujRXaNOIPvEN8DWi54YIlN7IbKtyvJpEZa+nIbCwv95tiKPT0H0sqvXn3NFyzLLfiperUFBguSPvAEYLuU6ammt754QHYPE4Vc1vmQk0WrxTaLbR5pA7uRDYGbPeS/XJi8DdfpA2/jkn/42GBe9U9LF9l4LUqJmKVpZHmpnT4L29MPcfijb94O666q1851bHtZ3gakJSF79usYYkWg1xouuJgLVBIqL81BKPxPe+mkSn1UqwOrx+zzvFiIJSBy4rn6rTkW0Vr/zRbAKy9wnJ573Y+t8TN0ULeyUPHk5RK+4NjwZ8mmFZ0VXEoFaAlr6GdAW5z3B4Gf/+N4fbQs07cz3QHvOO1whsuMARLZcVv8cSQUjtwL5+a9x+yBt2AaxA9evOx8kWolrXu/Rng1g244laFw84/zhLkc97kbnvIQhEkEHLnExTQ054oNI0Xki4E0AY7Xyp7zDHpisQvLQjW1Bt/L41wCMkkdbDJJHbgImepSxFxTIn34EjPM/4PYhuu8lgPFZ1UeQaI298E2BY7It0/lgkD/xP2DlLwZej/Fd8cOvDLwOqgpe0NfDYFx0BRGoI2BpOVid/08umbHnvbZlanrmOSic/rZnO8qmnaDuOuR5zrZsyH4HwxzW1XZYuxZFFa2mtbiuypl2iJb7EPzCqp97BoqnvhXIAUULxcv3MEsARvnDB4lWIFK6gAjUEwgKe3CCPVssiJo78U0wc95BofF9LwIxvtFzanA5ictK3hHZeRgiO2brTrdTtNzGS+nTgcLlBKDurvkCWts7LCuG1haJFv06EoHmCfiFPcT3vwTE6FjTjZvFLOSe/G/P+3G7TPzKF3Hb9usX3pR8/k8AWlu1RydEC/1d+e/+JxjL/IJcQmwcEkde5c+q4oQn0Wr6laIbiQCAX9hDq1Hxfl8no7uvAnliu+cU+MV04Q3SxA6I7bvO896OiBYA6Bd+CIUT3gLsdsTXX1ZTwJWWh/TbRwSaJOAnLC1FxWNQKDrgcZNw7SGIZQd8JSC09nR+4WEwlpe4I4rN3gjS2JauipazlP7WP/tSrg2/WHdxTQ1EEq0mX1i6jQj4hT1Etu2FSPV+wAZwlc59H4o/OO55B2ZjUHdc6XnOL6YLbxDUMUhc9RpuCuZOWVr47Oyjnwe7eCn7aO0AYgduBGmDh5h61D8k0WrgZaJLiUA1AWMlDflTnO01m6YhuutwU8ByT/0v4EZnryMxez0IEe8MEsVnn4LS2QXuMyO7roLI9v3c850Urdzxr4OZTfMtQJ5o1eSHxwZItJp6regmIgDgF/YgjU1C7IrGNwabuYuQO/G/nnjF5CaI7+FHkGcf/zrY+EvudTCh7ID3yRvfS9GKXvlSkMdr/HScKtMkWvTbRwSaJOAX9oD5qeJXvrjhlgvPPA76hUXP+6IzzwfZawmFzu7MGSicfpT7PHnzbojueaFvfzopWkE5vTyXh7gh3aoPrCXRavi1ohuIwCUCvPCCZqLibdOALDrgPbIyOAGhB2+oCwh1e5L73rfAXL3AX34dfAVIyc09E63sw/8Gts6xAgEgVtu/qkyltZ0m0aLfQCLQAgE/sWg0Kl5bOg3aD5/07I1fuhuzuAq5J/+LOwpBTUDi8KsBvLb8VN3VKUvLKq7C6qOf96WMEfqCEi1f4ywL0WnvHdFPotXCC0u3EoHC958AnbPHDy2jtV/EEKhwWxD6yeoPVk6nzPFHFRefBIw85x3qzkOgbN4FoGDx1nLuLK+jU6IVlCIH6zOOveANl7pUygPY5eh3r4NEK8TLRJcQAR4BvzTIsb0vBCkxHgqe3wZsdFBHL7uU92pdg05M19fXtrjUPQzjujCzqSCWBcun6nRHRAv798jnOJu+y72VNm6D2P5KxomamCwSrVCvD11EBMIT0JfPQmHhEc8bopdfA/LGraEayy88AsbyWc9r/cSvdO4HUPzBE9xnKJt3g7qzap+hj3B1QrQKCw+BvsQPw8COR3ZfDZGpK8sbonFjdMBBllYQITpPBHwIOP4ajj8pbFS8pRdh9YlveD7F8UcdeCm3B34xXXhT/MB1IKrJ9fdj1R7H4lq/VGy3aAXlp3c7lXzBG4DhcrCyITrohSPRCiJE54mADwHbtiD7qHe1G8wTjw70oEN79gRgTUOvo+yPKheeqD38YrrwWjE+DvF9PmEOUmydc74tomWZoD33PSideYqbQ796HE72UrQEeXnsPcZNohX0RtF5IhBAgBfUKW/aAdFdRwL5cYNCq/1RHq34xXTh5X4bq9eaExSASsaHINFSZ+qDZW1DB6uwAmbuAuDfnWIfoQXI/wMDDxyJVuArRRcQAX8CvLxXQRHs2Kp+8TkoPM1J9Ld5F6g7D3o+3C+my7lBlCB5CB3w/K+FlxrG5WIUVh78l65ONY7N+arZ4EGi1SAwupwI1BIofP9x0M/XR7EH+aOwndzJB8HMnveEmjjwMhBU7+Kmfpu1sTFl6wyo2703VvNmcOXbX+ja5CotVCwi0eraNNGDhpUAL+wBM5difBXv8Nu7GFQcA53/+BGAdzQaI4btdEu0nAwY267gZpsIek9ItIII0XkiEEBAv3gWCk97hz34RcUXf/gklJa8g0KxACsWYvU6jOx5yJ98kNurMMtSr5s7LVoYHBubeT43TXTYF41EKywpuo4IcAj4hT1wLR7LgpUnvgZg1kd+4y934tCN3ER/uDEaN0jzDr+N1X6T2CnRwvGo07NOviwnyLXFg0SrRYB0OxGwLatS/aaeRWzvj4KUqK80Uzq/CMXvP+4JT9m2B1ROqIRtlCD7xNfL+/M8jvLG6uu5gtct0RLUJCibdoA4Nunk/+JlWm3m7SHRaoYa3dPnBFilf96/2J3oPC9sgRd2gDmzMM7K60geejkwOeJ5TnvuFGhnTnCH0ErG1CBLS93hkUCQCYAfHIAxYILk1GHEvrfDouINkkSrE28wtdk7AsxdfpQrH/MyBbS7g7ywh8j0LEQmd697nJlbhtyJBzy7IG3cCrHLr+F2L7DSDu4z9En014ql1WjWinYzdtsj0eoUWWq3ywQYgFCptuyK1Zpodd7i4oU9eEXF+2WG4C0nEaa+vASFhYe5XIMEL2hCgiwtEq0ggnSeCIQlgNaVI1hV1lWdcIVtrLnreGEP8sQOiO6+FBXvFxTqxHXtv44bCoD56DEvPe/wE7wwoyLRMgwplkhItqbJt991B79SYxiadA0R4BEQFQBnSegjWF1YJvLCHmrjrbT0adAWvRP9qTsOgLLlMs+Rlivt3M8vda/EIDn7sqZjn/ChJFokWiQ0HSXAACS1nKnAazlY/TPbo35gm/tmFrKQ+259QVIWQTGp5IoCAG6iPyw8gf4oTnZRLHOP5e55R2THfohsubylUZFokWi19ALRzT4E0LKSomWrolaw1omV0cDm3daI25YJ2e98ub4RQYKxq17p/NzIXoD8yW95Pqh2GVl7kVO81eDlmmKQPIKCJ7c0CBItEq2WXiC6mUNAjACIaGEFLAdNHQCsrmLkhT2MXfVqAEGA/OlHweAEhcavfAmIsTHP/gZW2pnY7mR0aPUg0SLRavUdovtrCcgJALQmqr8K1lpalgVgYtWXzn8xrO0eL+wBgz3R71ZO9FffLzG+EeL7XsSd76BKO3gvttHqQaJFotXqO0T3uwTQb6VscKwV3+UgZr40iz3jxgt7iO25FsxcBtAv5XX4ZTgNrLQTTZa/OLbhINEi0WrDa0RNAH4dVMaC/VcoViHyi3eSKC/sQdqw1Yl+96r+jH6oBFba4VTJKS7OQyn9DLfb6s7DoGyebsuwSLRItNryIo10I7gcxLJXeHAd7hZAKedbcqpbDP0S+vH64Jv3CjdVowOelzsdvzgeualtW2ZItEi0uvW7MoTPYQDqBGA9vMDloFPUs7sOdx5wXtiD3wT55b3y21SNbdZV2mnxTSDRItFq8RUa0dtxmRTbAoApTPzCGbDclM5PgtcLetywB05nMFUL5pfiHatPPQBWfpl7Pr7/pSBGE20bKokWiVbbXqaRaii6CUCO+QuWlgUwC32JhVukwqO3fnmvWq600wQdEi0SrSZeG7oFEjv4VhZGthczABbGYPXnwQt7qO0tk6OQdEIh3DQ666/gfYl0r1J3HwFlYkdbIZBokWi19YUamcbiWwEwgLR2LyF+GUTB6sKWnFZYF05/B/TMs4FNRLZfCZGtM57XOctMxwHP2X4kyuDk3ApVaSewK2sXkGiRaIV/W+jKSwQwxCG+rfLvStQ7Ots174R5/YYO9wfy4rEu9dW/3p+2dBq0H3pvqsY2lC2Xg2dCvhZhkGiRaLX4Co3w7UwCiCTLSyc9D4BO9wE59AtnoPDMo769lce3Q/Qy/rabwEo7s9c7KYzbfZBokWi1+52i9gaAgJlfhtxT3llJ3e77bbvx21SN90tjkxC7or7SczvQkGiRaLXjPaI2BoyAk+Tvsa9wey1ExyCx/yXc88GVdq4BecPWjlAh0SLR6siLRY32PwFL5y9nseCDXwoZ3Opjcyrt4MgFKdJSoj8/en79dp4tq30Bv+M54hXDkG770K8uADDv+t59gYE6QQSIwKAQMEvGv336t+9+WzGfN7KiaMjptLEyPW3OApjzBw/aqVSqrqJJXWCJDcDuTKUY3HefMDs5KcwXi9JOxkTVNKUVRZHf9v5fuV8QBY/6Q4OCifpJBIhAvxDQVgt3ffYP7/l9rVAw8rJsaIuLZtOiNXv8OJsHEMcARF3TpKRpSmosJr3lD27/oBJV3tIvg6Z+EAEiMLgEMs+e++ljf/zpL+VF0Vi+eBFLdBtT+/aZ45mM1bClhaKVGR8XcpkMrrzFmK5LWU2Tb373bS/cumfqc4OLiXpOBIhAPxCwLTv9xQ/8wzXpxfOFYjZrrAiCkSuVzKls1hyfmWletJQTJ8Q8gFTauFGKmaakqKp025/84r+LknhtPwyc+kAEiMBgEiiu5N/3d7/z8Q9romhYxaIekSRDMwzzQqFgwg03WEePHrVZeWvUuhSxXpulGH7xuPPOO9mz994rbk8mxbiiiGOWJenJpBQxTelVb339oZ2HZ/6DMaYMJi7qNREgAr0kYJnmiS/c/fnXLp1azForK2ZeEIwLkmScNwxzkytaqZRdEagQogUArjN+IhoVL0iSOGEYkiQIIvq1dNOUfuq9t94ysW3TB3o5cHo2ESACA0jAhszJB46/7r//9f6nS8WioYjiJSf8yoo5OzvrfDk8WhatukT8ntvS3S+I1c549GuVdF2aYEwsqapkGIY09865109s2/ynTGDJAURHXSYCRKDLBAzdnD/50JPveODf/+dESdMMWZIMM5Mxw/qzsLveuTQAWAqAzc7NsczCgnCmskSMiKIojY+Lqq471pYQjYpXvfjQ1JGXX/2eSEx9o097XUZDjyMCRKCfCNhgr2bPr3zgS5+4955CeqWwCmBKFStrybLMgm2bYZaGvqKFNll1vNZiOckI1swVdcOQRABRiUQkBiDin/3XHdl62ZGZH9kwkXyRJEs7+wkY9YUIEIEeEGDM1PLFx5aXLv7fE//17UcWT51dtRkzrULBlEXRKMqyYeA16bTpfDWsCnXgLQ1DiZYT+rCwIGhbtggRSRIlxkRBEMQSWlqJhCjYtmiJosBsW7R1XRBlmVm6LhiyzDCTkm6a66w5/BkdRIAIDA8BrLjgLDUAAAQMSURBVEzpHrIoOj4oUxBsSddtSxRtZllWyTQtFYvCmaZl2bbpLAsBTCwUpwGY0wDmZDptpScn7fljx+xU2ZflWfCStzx0BA3vODY3J0ym0yw9OSnk4nHhnGmKEcsSJdsW45Ik5G1bFHI5R7gioiiIpsnyoijgzibDNBmK2PBMD42ECBABPwJFTQMZBUsUbRQuWdftkqJYgmlaKFhRADNvGJZu22bJssyNtm1imENkaclyY7MqVhY+pmHRwjucLT2utTU+M8NwmbhZVQVdlgXhwgXRxP8DiKYkCZamCZKiMMk0WUlRGAoYPrnW2qJpJwJEYPgIuFYWZvxXSiVbEUXbEEXbESxVtQTDsETDwByupqRplmHbppLNWvHJSWs+nbaOT07aBwOsLL/loUvUsbZc39ZUNstwmWgkEkJ8fJyNZzJCBgVLloV4oSDIqsqWi0VBUlVWMgyGqc1K7vIw1v5EZ8M37TQiIjCgBPL5tY6jWOG/FEmyUaT0yv9FXbfkeNxaLpUsqVi0lE2brHguZ1UvC48CeMZmVVMJs3RzviQen5tjB9Np5gpXcutWFs/lWLFidRnZrKDE40wplVimUBAwBqKoqmvta4YR5lkDOmPUbSIw2gQikrRuKacXi7YqSXZJlu1oPm+jWGnZrC1v2GCpxaKVS6dttLDWBOtSXBZ3WbhmSYVAXba2aoQLl4rPra4ytLrM5WUhtmEDUzWN5XSdTUxMQK5UYoqus4Kul8Vqw4a1RxXdn4V4OF1CBIhAfxJQZfmSUC2XazpGKz9DsYorio1CVYxE7KSq2oWLF+2cqtrS6qp1IZGwpxYWbNePBakU+DnfG7W0nGWkK1zYOPq40Dl/Yt8+XCKy+XRaGJucZCvFIpsCgJWNGxnmY8wWi2xV0xzR2lz1VBS2/pwG6hURIAJhCcSrRQsAzgFAIhJxhAxF6uzZszAWiThCNR6P29mzZ+1tiYSdWViwzyST9ix+KWzAwmrE0lq71pVV1zmPJxzxymbZmZkZNrG66ojRha1b2W4AyORynuKE4hYWDF1HBIhA/xIYU1XPL3woUs+cPg0T0WhZqMbHbXj4YXDF6hgAoNM9jA+rdvTNiEed1eU2Op9Os+sBAC0w/NmZTKaZ9vt3hqhnRIAIhCIwVRGpfcmkfT8AoFWFN6Jl5TSQSkEzguUs+0L1oP6itXwR6OvCDrgHLh292kRBa/JZdBsRIAJ9TsAVJc/ffVeoAABjsKqEx9NKCxpqq0JSl+ymVsSCOkDniQARGF4Crkh5WEhNCVYrlhaP8poINt2j4Z0/GhkRGCkCNRZR2yShVUtrpCaBBksEiEDvCZBo9X4OqAdEgAg0QIBEqwFYdCkRIAK9J0Ci1fs5oB4QASLQAIH/B0gvcY9YRFPXAAAAAElFTkSuQmCC);
}


.sign_date {
    font-size: 10px;
    font-weight: 500;
    // line-height: 14px;
    color: #333333;

}


.sign_list {
    width: 94%;
    margin: 0 auto;
    padding: 24px 18px;
    height: 306px;
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
    box-shadow: 0px 3px 15px rgba(153, 155, 158, 0.2);

    border-radius: 14px;
    position: relative;
    box-sizing: border-box;
    margin-bottom: 12px;


}

.sign_item {
    width: 25%;
    // height: 81px;
    box-sizing: border-box;
    margin-bottom: 14px;

    .item_model {
        margin: 0 7px;
        background: #EEEEEE;
        border-radius: 4px;
        text-align: center;
        padding: 8px 0;
        // .sign_date{
        //     font-size: 10px;
        //
        //     font-weight: 400;
        //     // line-height: 14px;
        //     color: #333333;
        //
        // }
        .sign_img {
            width: 100%;
            height: 34px;
            img {
                width: 34px;
                height: 34px;
            }
        }
        .sign_status {

            font-size: 12px;
            font-weight: 500;
            // line-height: 17px;
            color: #999999;

        }

    }

    .end_state {

        font-size: 9px;
        font-weight: 400;
        color: #999999;

        margin-bottom: 14px;
    }

    .item_end {
        margin: 0 7px;
        background: #EEEEEE;
        border-radius: 4px;
        padding: 8px;

        .end_img {
            width: 100%;
            height: 24px;
            text-align: right;
            img {
                width: 39px;
                height: 24px;
            }
        }


    }
}


.btn_sign {
    width: 100%;
    height: 40px;
    text-align: center;
    img {
        width: 267px;
        height: 40px;
    }
}

.day_sign {
    width: 100%;
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    font-weight: 500;
    color: #333333;

}

</style>
